import { STAKING_ACTION } from '../../constants/actions'

const changeStakingState = (property, value) => ({
  type: STAKING_ACTION.CHANGE_STATE,
  payload: { property, value }
})

const resetStakingState = () => ({
  type: STAKING_ACTION.RESET_STATE
})

const getClaimStatus = () => ({
  type: STAKING_ACTION.GET_CLAIM_STATUS
})

const getClaimStatusSuccess = (data) => ({
  type: STAKING_ACTION.GET_CLAIM_STATUS_SUCCESS,
  payload: data
})

const getClaimStatusFailed = (error) => ({
  type: STAKING_ACTION.GET_CLAIM_STATUS_FAILED,
  payload: { error }
})

const claimStake = () => ({
  type: STAKING_ACTION.CLAIM_STAKE
})

const claimStakeSuccess = (data) => ({
  type: STAKING_ACTION.CLAIM_STAKE_SUCCESS,
  payload: data
})

const claimStakeFailed = (error) => ({
  type: STAKING_ACTION.CLAIM_STAKE_FAILED,
  payload: { error }
})

export {
  changeStakingState,
  resetStakingState,
  getClaimStatus,
  getClaimStatusSuccess,
  getClaimStatusFailed,
  claimStake,
  claimStakeSuccess,
  claimStakeFailed
}
